import { render, staticRenderFns } from "./BorderCrossingsBarChart.vue?vue&type=template&id=4e4c1e7a&scoped=true"
import script from "./BorderCrossingsBarChart.vue?vue&type=script&lang=ts"
export * from "./BorderCrossingsBarChart.vue?vue&type=script&lang=ts"
import style0 from "./BorderCrossingsBarChart.vue?vue&type=style&index=0&id=4e4c1e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4c1e7a",
  null
  
)

export default component.exports